import UIComponent from "../ui/component";

export class FolderSelect extends UIComponent {
    init() {

        console
        this.on("change", this.onChange.bind(this));
    }

    onChange() {
        const folderId = this.element.value;
        let url;

        if (folderId === '') {
            url = this.data("url").replace('/folder/FOLDER_ID', '');
        } else {
            url = this.data("url").replace('FOLDER_ID', folderId);
        }

        window.location.href = url;
    }
}
